import { Typography, AntTag, defaultTheme } from '@agro-club/agroclub-shared'
import { CustomScroll } from 'views/styled/common'
import styled from 'styled-components'

export const WrapperBoard = styled.div`
  display: flex;
  align-items: flex-start;

  .ant-collapse {
    max-height: calc(100dvh - 160px);
    box-shadow: none;
    border: 1px solid ${defaultTheme.color.secondary50};
    border-bottom: none;
  }
  .ant-collapse-item:last-child {
    border-bottom: 1px solid ${defaultTheme.color.secondary50};
  }

  .ant-collapse-content-box {
    max-height: calc(100dvh - 350px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 16px 0 16px;
    margin-right: 2px;

    ${CustomScroll}
  }
  .ant-collapse-content {
    border-top: none;
  }
`
export const WrapperCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px 0;
  padding: 10px 0 16px 0;
`
export const Count = styled(AntTag).attrs({
  counter: true,
})`
  ${Typography.accentMedium}
  border: none;
  margin-left: 4px;
  padding: 0 8px;
`

export const WrapperCollapse = styled.div`
  width: 330px;
  margin-right: 24px;
  height: 100%;
`
export const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 16px;
  height: calc(100dvh - 130px);
  overflow: auto;
  ${CustomScroll}
`
